import { Node } from '@tiptap/core'

export const ChartSignature = Node.create({
  name: 'chart_signature',

  group: 'block',
  atom: true,
  selectable: false,
  isolating: true,

  addAttributes() {
    return {
      provider_name: { default: null },
      credentials: { default: null },
      specialty: { default: null },
      signed_at: { default: null },
      signature_url: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'chart-signature' }]
  },

  renderHTML() {
    return ['chart-signature', {}]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('chart-signature')
      dom.className = 'chart_signature'
      dom.tabIndex = -1

      const line = document.createElement('div')
      line.className = 'chart_signature_line'

      const name = document.createElement('div')
      name.className = 'chart_signature_name'
      name.textContent =
        node.attrs.provider_name
          ? `${node.attrs.provider_name}, ${node.attrs.credentials}`
          : 'Provider Signature Pending'

      const specialty = document.createElement('div')
      specialty.className = 'chart_signature_specialty'
      specialty.textContent = node.attrs.specialty || ''

      const signedAt = document.createElement('div')
      signedAt.className = 'chart_signature_date'
      signedAt.textContent =
        node.attrs.signed_at
          ? `Signed: ${node.attrs.signed_at}`
          : ''

      line.appendChild(name)
      line.appendChild(specialty)
      line.appendChild(signedAt)

      dom.appendChild(line)

      if (node.attrs.signature_url) {
        const img = document.createElement('img')
        img.className = 'chart_signature_image'
        img.src = node.attrs.signature_url
        img.alt = 'Provider Signature'
        dom.appendChild(img)
      }

      return { dom }
    }
  },
})
